import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-attendance',
  templateUrl: './edit-attendance.component.html',
  styleUrls: ['./edit-attendance.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditAttendanceComponent implements OnInit {
  @ViewChild('fileInput') myInputVariable: ElementRef;

  attendanceId:any;
  attendanceData={
    user:'',
    startTime:'',
    endTime:'',
    attendanceDate:'',
    notes:'',
    task:'',
  }
  constructor( private activatedroute:ActivatedRoute,
    public toastr: ToastrService,
    public apiService:ApiService,
    private route:Router) { 
      this.activatedroute.paramMap.subscribe(params => { 
        this.attendanceId = params.get('id'); 
        console.log('attendanceId ',this.attendanceId)
      })
    }

  ngOnInit(): void {
    this.getAttendanceByUserId();
  }
getAttendanceByUserId(){
  if(this.attendanceId){
    this.apiService.getAttendanceByUserId(this.attendanceId,1,100,'','').subscribe((res:any)=>{
      this.attendanceData=res.data[0];
      this.attendanceData.attendanceDate=moment(this.attendanceData.attendanceDate).format('DD-MM-YYYY')

    })
  }
  else{
    this.toastr.error('Something went wrong!!')
  }
}
updateAttendance(){
  if(this.attendanceId){
    this.apiService.updateAttendance(this.attendanceId,this.attendanceData).subscribe((res:any)=>{
      if(res.isSuccess === true){
        console.log('res==>>',res)
        this.toastr.success(res.message)
      }
      else{
        this.toastr.error(res.error)
      }
    })
  }
  else{
    this.toastr.error('Something went wrong!!')
  }
}
back(){
  this.route.navigate(['/attendance/attendance-list'])
}



}
